
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-05-14-dalai-lama-review",
      function () {
        return require("private-next-pages/blogs/2023-05-14-dalai-lama-review/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-05-14-dalai-lama-review"])
      });
    }
  